import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {TenantResponse, TenantsClient, TenantUpdateRequest} from '../../../generated-client/generated-api-client';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {FormGroup} from '@angular/forms';
import {TenantService} from '../../../services/tenant.service';
import {isFormModifiedDataService} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-tenant-edit',
  templateUrl: './tenant-edit.component.html',
  styleUrls: ['./tenant-edit.component.sass'],
})
export class TenantEditComponent {
  id: string;
  response!: Observable<TenantResponse>;

  constructor(
    private _route: ActivatedRoute,
    private _titleService: Title,
    private _router: Router,
    private _tenantsClient: TenantsClient,
    private _errorProcessorService: ErrorProcessorService,
    private _tenantService: TenantService,
    private _isFormModifiedDataService: isFormModifiedDataService,
  ) {
    this.id = '';
    this._titleService.setTitle('Terület módosítása');
    this._route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id') ?? '';
    });
  }

  ngOnInit(): void {
    this.response = this._tenantsClient.get(this.id);
  }

  async onSubmit(form: FormGroup): Promise<void> {
    const request: TenantUpdateRequest = {
      id: form.get('id')?.value === '' ? null : form.get('id')?.value,
      name: form.get('name')?.value === '' ? null : form.get('name')?.value,
      systemId: form.get('systemId')?.value === '' ? null : form.get('systemId')?.value,
      examReportModifiableLater: form.get('examReportModifiableLater')?.value,
    };
    const response = await this._tenantsClient.edit(request);
    response.subscribe(
      next => {
        this._tenantService.refreshTenantSelectList(this._tenantsClient);
        this._isFormModifiedDataService.isFormModified = false;
        this._router.navigate(['/tenants']);
      },
      error => this._errorProcessorService.processError(error, true)
    );
  }
}
